import { callbackIntents } from '../consts';

// onPaymentDataChanged callback must be set if any of SHIPPING_ADDRESS,SHIPPING_OPTION,OFFER,PAYMENT_METHOD callback intent is set.
const onPaymentDataChangedCallback: google.payments.api.CallbackIntent[] = [
  callbackIntents.SHIPPING_ADDRESS,
  callbackIntents.SHIPPING_OPTION,
  callbackIntents.PAYMENT_METHOD,
  callbackIntents.OFFER,
];

export const getIsNeedPassOnPaymentDataChanged = (
  intents: google.payments.api.PaymentDataRequest['callbackIntents'],
): boolean => intents!.some((intentName) => onPaymentDataChangedCallback.includes(intentName));
